import http from '@/http/aisea/axios'
const resource = "/enterprise/vessels/";

export default {
  getChannelOrigins(enterpriseVesselId) {
    return http.get(`${resource}${enterpriseVesselId}/channel_origins`);
  },

  getChannelGroups(enterpriseVesselId, channelOriginId) {
    return http.get(`${resource}${enterpriseVesselId}/channel_origins/${channelOriginId}/channel_groups`);
  },

  getChannels(enterpriseVesselId, channelOriginId, channelGroupId, payload) {
    return http.get(`${resource}${enterpriseVesselId}/channel_origins/${channelOriginId}/channel_groups/${channelGroupId}/channels`, { params: payload });
  },


  // update(vesselId, linkId, payload) {
  //   return http.put(`${resource}${vesselId}/documents/${linkId}`, payload);
  // },

  // add(vesselId, payload) {
  //   return http.post(`${resource}${vesselId}/documents`, payload);
  // },

  // delete(vesselId, linkId) {
  //   return http.delete(`${resource}${vesselId}/documents/${linkId}`);
  // },

};
